// Small vector + coordinate helpers used across the simulation.
// Deliberately dependency-free and Three.js-free.

import { CHUNK_SIZE_X, CHUNK_SIZE_Z } from './constants';

export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

export function vec3(x = 0, y = 0, z = 0): Vec3 {
  return { x, y, z };
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Integer floor division that works for negative numbers. */
export function floorDiv(a: number, b: number): number {
  return Math.floor(a / b);
}

/** Euclidean modulo — always returns a result in [0, b). */
export function mod(a: number, b: number): number {
  return ((a % b) + b) % b;
}

/** Chunk column key from world block coordinates. */
export function chunkKey(cx: number, cz: number): string {
  return `${cx},${cz}`;
}

export function worldToChunkX(x: number): number {
  return floorDiv(x, CHUNK_SIZE_X);
}

export function worldToChunkZ(z: number): number {
  return floorDiv(z, CHUNK_SIZE_Z);
}

/** Local X within a chunk for a world X. */
export function localX(x: number): number {
  return mod(x, CHUNK_SIZE_X);
}

export function localZ(z: number): number {
  return mod(z, CHUNK_SIZE_Z);
}
